import { DatagridConfigurableProps } from 'shared/react-admin/Datagrids/DatagridConfigurable/DatagridConfigurable';

import {
  ContainerStyled,
  DatagridResizableStyled,
  DatagridStyled,
} from './DatagridConfigurableWithStickyActions.styled';

export type DatagridConfigurableWithStickyActionsProps = DatagridConfigurableProps;

export const DatagridConfigurableWithStickyActions = (
  props: DatagridConfigurableWithStickyActionsProps,
) => {
  if (!props.resizableColumns) {
    return <DatagridStyled {...props} />;
  }

  return (
    <ContainerStyled>
      <DatagridResizableStyled {...props} />
    </ContainerStyled>
  );
};
